<template>
  <f-form
    store="@admin/partners"
    :id="partnerId"
  >
    <template #default="{ item }">
      <div class="is-aligned-right m-bottom-12">
        <f-button
          v-if="canEdit"
          @click="addContact(item)"
          size="small"
          fill
        >
          <i class="uil uil-plus"></i> Créer 
        </f-button>
      </div>

      <div 
        v-for="(contact, index) in item.contacts"
        :key="index"
        class="is-grid"
      >
        <f-field 
          class="is-col-6"
          label="Prenom"
        >
          <f-input 
            v-model="contact.firstname"
            suffix-icon="user"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Nom"
        >
          <f-input 
            v-model="contact.lastname"
            suffix-icon="user"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Email"
        >
          <f-input 
            v-model="contact.email"
            suffix-icon="envelope-alt"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Téléphone"
        >
          <f-input 
            v-model="contact.phone"
            suffix-icon="phone"
            :readonly="!canEdit"
          ></f-input>
        </f-field>

        <div class="is-aligned-right m-vertical-12">
          <f-button
            @click="removeContact(item, index)"
            :readonly="!canEdit"
            size="small"
            fill
          >
            <i class="uil uil-trash-alt"></i>
          </f-button>
        </div>

        <div class="is-col-12">
          <hr>
        </div>
      </div>
    </template>
  </f-form>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'

  export default {
    props: {
      id: {
        type: String, 
        required: true,
      },
    },

    setup (props) {
      const { get, patch } = useStore('@admin/partners')
      const { checkPermissions } = useRoles()
      const partnerId = ref(props.id)

      const canEdit = computed(() => 
        checkPermissions('partners:patch')
      )

      function addContact (item) {
        if (!item.contacts) {
          item.contacts = []
        }
        item.contacts.push({ 
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
        })
      }

      function removeContact (item, index) {
        item.contacts.splice(index, 1)
      }
      
      return {
        canEdit,
        partnerId,
        addContact, 
        removeContact,
      }
    } 
  }
</script>